function questionaireModule() {
    this.init = function () {
        setTimeout(function () {
            $("#questionaire-signing-loader span").text(
                "Bezig met het samenvoegen van al uw vragenlijsten."
            );
        }, 2000);

        setTimeout(function () {
            $("#questionaire-signing-loader span").text(
                "Bezig met het klaarzetten voor ondertekening."
            );
        }, 4000);

        setTimeout(function () {
            $("#questionaire-signing-loader span").text(
                "Bijna klaar. We sturen u zo door."
            );
        }, 6000);

        Livewire.on("singingUrlReady", (singingUrl) => {
            window.location.href = singingUrl;
        });
    };
}

module.exports = questionaireModule;
